<div class="row branding-upload">
  <div class="col-auto">
      <span class="btn-group">
         <button (click)="uploader.click()"
                 title="{{'Upload Image' | translate}}"
                 [disabled]="!isAdminRole && !isSuperAdminRole || brandingIsLoading"
                 class="btn btn-primary">
              <span class="fa-solid fa-upload"></span>
          </button>
        <button (click)="onResetImage()"
                title="{{'Reset Image' | translate}}"
                [disabled]="!isAdminRole && !isSuperAdminRole || brandingIsLoading"
                class="btn btn-outline-primary">
          <span class="fa-solid fa-rotate-left"></span>
          </button>
      </span>
  </div>
  <div class="col-auto">
    <label>
      <span translate [innerText]="title"></span>
      <ng-template #popContent>
        <div [style.min-width.px]="200" [innerHTML]="popoverDetails.content"></div>
      </ng-template>
      <ng-template #popTitle>
        <div [innerHTML]="popoverDetails.title"></div>
      </ng-template>
      <span [ngbPopover]="popContent" [popoverTitle]="popTitle"
            [autoClose]="'outside'">
                <span class="fa-solid fa-circle-question"></span>
          </span>
    </label>
    <div (click)="uploader.click()">
      <div class="logo-image" [ngClass]="'logo-image-'+name">
        <div class="logo-image-wrapper"
             [ngStyle]="{'background-color':background}">
          <img [style.max-width.px]="recommendedSize.width"
               [style.max-height.px]="recommendedSize.height"
               [src]="image | safeImageUrl"
               (error)="onImageError($event)"
               id="{{'img_'+name}}"
               class="large">
        </div>
        <input type="file"
               [hidden]="true"
               #uploader
               id="{{'logo_'+name}}"
               accept="{{'.'+imageType}}"
               (change)="onFileSelected($event)"
               class="hidden-file-upload"
               [disabled]="!isAdminRole && !isSuperAdminRole || brandingIsLoading"/>
      </div>
    </div>
  </div>
</div>

